export default '/build/72774215.svg'